import React from 'react';
import Logo from './Logo';

// Top-level error boundary: a render/runtime error in any page shows a
// recoverable card with a Reload button instead of a white screen. Reload
// re-initializes the whole app (fresh Firestore connection + cache lease), which
// is the reliable last-resort recovery for a wedged client.
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Something went wrong.' };
  }

  componentDidCatch(error, info) {
    // Surface for diagnosis; a real deployment would forward this to Sentry.
    console.error('App crashed:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="loading-page">
        <Logo variant="icon" width={48} />
        <p style={{ marginTop: 12, fontWeight: 600 }}>Something went wrong.</p>
        <p style={{ marginTop: 4, color: 'var(--color-text-muted, #5F5E5A)', fontSize: 14, maxWidth: 320, textAlign: 'center' }}>
          The app hit an unexpected error. Reloading usually fixes it.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginTop: 16 }}
          onClick={() => window.location.reload()}
        >
          Reload app
        </button>
      </div>
    );
  }
}
